var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlutorixLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.2405 15.76L70.1703 30.3473L70.1721 30.3538L74.0494 44.9031C74.64 47.1193 74.0189 49.4827 72.4151 51.1222L62.0215 61.7475L51.1066 72.4289C49.4728 74.0278 47.1192 74.6509 44.9083 74.0699L30.087 70.175L30.0755 70.1719L15.7635 66.2612C13.5547 65.6577 11.8264 63.9364 11.2137 61.7301L7.10274 46.9247L3.37919 32.4918C2.81968 30.3231 3.41611 28.0191 4.95764 26.3943L15.5271 15.2538L26.4077 4.94149C28.0267 3.40702 30.3195 2.80994 32.4814 3.35984L47.1987 7.10342L61.726 11.1941C63.93 11.8147 65.6449 13.5491 66.2405 15.76Z",
    stroke: "white",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlutorixLogo);
export default __webpack_public_path__ + "static/media/plutorix_logo.423fb68bf2aa297eadad9d8108aa8d01.svg";
export { ForwardRef as ReactComponent };